import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GermplasmService } from '../germplasm/service/germplasm.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SubscriptionsManager } from '../util/subscriptions-manager';

@Component({
    selector: 'jhi-column-filter-attributes',
    template: `
		<form #f='ngForm'>
			<section class="filter-wrapper">
				<div class="keyword-wrapper">
					<input type="text" class="form-control" [formControl]="queryField" id="keyword" placeholder="{{ attributesPlaceHolder | translate }}" autofocus/>
				</div>
				<ul class="filter-select">
					<li *ngFor="let result of results" class="filter-select-list" (click)="addAttribute(result)">
						<div>
							<img class="variable-select-icon" alt="Property" src="/ibpworkbench/controller/static/images/property.svg">
							<span> {{result.property.name}} </span>
						</div>
						<div>
							<img class="variable-select-icon" alt="Variable" src="/ibpworkbench/controller/static/images/variable.png">
							<span *ngIf="result.alias"  class="label-info"> {{result.alias}} ({{result.name}})</span>
							<span *ngIf="!result.alias" class="label-info"> {{result.name}}</span>
						</div>
					</li>
				</ul>
			</section>
			<div *ngIf="this.filter.attributes.length === 0"><span>{{ 'column-filter.attributes.label' | translate }}</span></div>
			<br/>
			<div *ngFor="let attribute of filter.attributes">
				<div class="mb-3">
					<label *ngIf="attribute.alias" for="{{attribute.name}}">{{attribute.name}} ({{attribute.alias}})</label>
					<label *ngIf="!attribute.alias" for="{{attribute.name}}">{{attribute.name}}</label>
					<div class="input-group">
						<input type="text" class="form-control" [(ngModel)]="attribute.value" name="{{attribute.name}}">
							<button class="btn btn-outline-info float-end fa fa-minus" (click)="deleteAttribute(attribute)"></button>
					</div>
				</div>
			</div>
			<br/>
			<div class="footer text-center"><br>
				<button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
				<button class="btn btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
			</div>
		</form>
    `
})
export class ColumnFilterAttributesComponent implements OnInit, OnDestroy {

    queryField: FormControl = new FormControl();
    results: any[] = [];

    @Input() filter: any;

    @Output() onAdd = new EventEmitter();
    @Output() onDelete = new EventEmitter();
    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();

    attributesPlaceHolder: string;
    subscriptionManager = new SubscriptionsManager();

    constructor(private germplasmService: GermplasmService) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.subscriptionManager.add = this.queryField.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap((query) => this.germplasmService.searchAttributes(query))
        ).subscribe((result) => {
            if (result.status === 400) {
                return;
            } else {
                this.results = result.body;
            }
        });
        this.attributesPlaceHolder = this.filter.placeholder ? this.attributesPlaceHolder : 'column-filter.attributes.placeholder';
    }

    addAttribute(attribute) {
        // Reset query field value
        this.queryField.setValue('');
        // Do not add attribute if it's already in the list
        if (!this.filter.attributes.some((e) => e.name === attribute.name)) {
            this.filter.attributes.push({ ...attribute, value: '' });
        }
        this.onAdd.emit(attribute);
    }

    deleteAttribute(attribute) {
        this.filter.attributes = this.filter.attributes.filter((e) => e.name !== attribute.name);
        this.onDelete.emit(attribute);
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
